import React, { useCallback, useEffect, useState } from 'react';
import { getAccessToken } from '../http';
import { toast } from 'react-toastify';

const DropUpload = ({ titleText, fileText, maxSize, submitFile }) => {
	const submit = e => {
		const max = parseInt(maxSize);
		if (max < e.target.files[0].size) {
			toast('File too large', {
				autoClose: 6000,
				type: toast.TYPE.ERROR,
			});
		} else {
			submitFile(e);
		}
	};

	return (
		<div className="py-4 mt-1 flex justify-center bg-white rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
			<div className="space-y-1 text-center" id="the-drop-zone">
				<svg
					className="mx-auto h-12 w-12 text-gray-400"
					stroke="currentColor"
					fill="none"
					viewBox="0 0 48 48"
					aria-hidden="true">
					<path
						d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
						strokeWidth={2}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
				<div className="flex text-sm text-gray-600">
					<label
						htmlFor="file-upload"
						className="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500">
						<span>{titleText}</span>
						<input
							id="file-upload"
							onChange={e => submit(e)}
							name="file-upload"
							type="file"
							className="sr-only"
						/>
					</label>
				</div>
				<p className="text-xs text-gray-500">{fileText}</p>
			</div>
		</div>
	);
};

export default DropUpload;
